"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1681],{

/***/ 31681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ readConsolidatedFlowImpact; },
/* harmony export */   "B$": function() { return /* binding */ readSessionDefaults; },
/* harmony export */   "DD": function() { return /* binding */ downloadSessionLeadBookersDataInCSV; },
/* harmony export */   "F7": function() { return /* binding */ archiveSession; },
/* harmony export */   "Ff": function() { return /* binding */ editSession; },
/* harmony export */   "LV": function() { return /* binding */ readSessions; },
/* harmony export */   "SA": function() { return /* binding */ readSessionsAggregated; },
/* harmony export */   "SO": function() { return /* binding */ deleteSession; },
/* harmony export */   "Wz": function() { return /* binding */ getSessionScanStatistics; },
/* harmony export */   "bf": function() { return /* binding */ readSession; },
/* harmony export */   "d$": function() { return /* binding */ downloadSessionHistoricalDataInCSV; },
/* harmony export */   "ed": function() { return /* binding */ createSession; },
/* harmony export */   "f3": function() { return /* binding */ unarchiveSession; },
/* harmony export */   "fV": function() { return /* binding */ readAllSessionDetails; },
/* harmony export */   "lR": function() { return /* binding */ downloadSessionDataInCSV; },
/* harmony export */   "mM": function() { return /* binding */ readScannerPageSessions; },
/* harmony export */   "nn": function() { return /* binding */ readSessionsAudience; },
/* harmony export */   "qb": function() { return /* binding */ updateSessionSortIndexes; }
/* harmony export */ });
/* unused harmony exports readSessionDetails, readSessionDashboard */
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53901);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89092);



function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var readSessionsAggregated = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(showId, pageSize, fromDate, toDate) {
    var url, res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = "/api/backend/v1/sessions";
            url = url + "?showIdFilter=".concat(showId, "&pageSize=").concat(pageSize, "&excludeDeleted=true");
            if (fromDate) url += "&fromDate=".concat(fromDate);
            if (toDate) url += "&toDate=".concat(toDate);
            _context.next = 7;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(url);

          case 7:
            res = _context.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context.next = 10;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 10:
            _context.next = 12;
            return res.json();

          case 12:
            resJson = _context.sent;
            return _context.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .SessionsAggregatedResponse */ .N7({
              data: {
                sessions: resJson === null || resJson === void 0 ? void 0 : resJson.sessions,
                shows: resJson === null || resJson === void 0 ? void 0 : resJson.shows,
                sessionDetailsDict: resJson === null || resJson === void 0 ? void 0 : resJson.sessionDetailsDict
              }
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .SessionsAggregatedResponse */ .N7({
              error: message
            }));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function readSessionsAggregated(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var readSessionDefaults = /*#__PURE__*/function () {
  var _ref2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
    var res;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions/defaults");

          case 2:
            res = _context2.sent;

            if (res.ok) {
              _context2.next = 5;
              break;
            }

            throw new Error("Unable to load session defaults");

          case 5:
            _context2.next = 7;
            return res.json();

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function readSessionDefaults() {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * What switching this session to the consolidated flow would cost right now, so the form can
 * warn with real numbers before the admin commits (TTT-688 §10.1). Safe to call for any
 * session: an already-consolidated one answers `wouldSwitchFlow: false`.
 */

var readConsolidatedFlowImpact = /*#__PURE__*/function () {
  var _ref3 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(sessionId) {
    var res;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions/".concat(sessionId, "/consolidated-flow-impact"));

          case 2:
            res = _context3.sent;

            if (res.ok) {
              _context3.next = 5;
              break;
            }

            throw new Error("Unable to load the consolidated flow impact");

          case 5:
            _context3.next = 7;
            return res.json();

          case 7:
            return _context3.abrupt("return", _context3.sent);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function readConsolidatedFlowImpact(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
var readSessions = /*#__PURE__*/function () {
  var _ref4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(showId, pageSize, fromDate, toDate) {
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", readSessionsInternal(showId, pageSize, fromDate, toDate, false));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function readSessions(_x6, _x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
var readScannerPageSessions = /*#__PURE__*/function () {
  var _ref5 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(showId, pageSize, fromDate, toDate) {
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", readSessionsInternal(showId, pageSize, fromDate, toDate, true));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function readScannerPageSessions(_x10, _x11, _x12, _x13) {
    return _ref5.apply(this, arguments);
  };
}();
var readSessionsAudience = /*#__PURE__*/function () {
  var _ref6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(showId, pageSize, promoCode, fromDate, toDate) {
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", readSessionsInternal(showId, pageSize, fromDate, toDate, true, promoCode));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function readSessionsAudience(_x14, _x15, _x16, _x17, _x18) {
    return _ref6.apply(this, arguments);
  };
}();

var readSessionsInternal = /*#__PURE__*/function () {
  var _ref7 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(showId, pageSize, fromDate, toDate, isAudienceView, promoCode) {
    var url, res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            url = isAudienceView ? "/api/backend/v1/sessions/audience" : "/api/backend/v1/sessions";
            url = url + "?showIdFilter=".concat(showId, "&pageSize=").concat(pageSize, "&excludeDeleted=true");
            if (fromDate) url += "&fromDate=".concat(fromDate);
            if (toDate) url += "&toDate=".concat(toDate);
            if (promoCode) url += "&promoCode=".concat(promoCode);

            if (!isAudienceView) {
              _context7.next = 12;
              break;
            }

            _context7.next = 9;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)(url);

          case 9:
            _context7.t0 = _context7.sent;
            _context7.next = 15;
            break;

          case 12:
            _context7.next = 14;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(url);

          case 14:
            _context7.t0 = _context7.sent;

          case 15:
            res = _context7.t0;

            if (!(res.status >= 400 && res.status < 600)) {
              _context7.next = 18;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 18:
            _context7.next = 20;
            return res.json();

          case 20:
            resJson = _context7.sent;
            return _context7.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .SessionsResponse */ .Qi({
              data: resJson === null || resJson === void 0 ? void 0 : resJson.sessions
            }));

          case 24:
            _context7.prev = 24;
            _context7.t1 = _context7["catch"](0);

            if (_context7.t1 instanceof Error) {
              message = _context7.t1.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context7.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .SessionsResponse */ .Qi({
              error: message
            }));

          case 28:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 24]]);
  }));

  return function readSessionsInternal(_x19, _x20, _x21, _x22, _x23, _x24) {
    return _ref7.apply(this, arguments);
  };
}();

var readSession = /*#__PURE__*/function () {
  var _ref8 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(sessionId, promoCode) {
    var url, res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            url = "/api/backend/v1/sessions/".concat(sessionId);
            if (promoCode) url += "?promoCode=".concat(promoCode);
            _context8.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)(url);

          case 5:
            res = _context8.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context8.next = 8;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 8:
            _context8.next = 10;
            return res.json();

          case 10:
            resJson = _context8.sent;
            return _context8.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .SessionResponse */ .c5({
              data: resJson
            }));

          case 14:
            _context8.prev = 14;
            _context8.t0 = _context8["catch"](0);

            if (_context8.t0 instanceof Error) {
              message = _context8.t0.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context8.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .SessionResponse */ .c5({
              error: message
            }));

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 14]]);
  }));

  return function readSession(_x25, _x26) {
    return _ref8.apply(this, arguments);
  };
}();
var readAllSessionDetails = /*#__PURE__*/function () {
  var _ref9 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(showId) {
    var url, res, resJson, result, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            url = "/api/backend/v1/sessions/details/byshowid/".concat(showId);
            _context9.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(url);

          case 4:
            res = _context9.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context9.next = 7;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 7:
            _context9.next = 9;
            return res.json();

          case 9:
            resJson = _context9.sent;
            result = resJson.sessionDetailsDict;
            return _context9.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .AllSessionDetailsResponse */ .FU({
              data: result
            }));

          case 14:
            _context9.prev = 14;
            _context9.t0 = _context9["catch"](0);

            if (_context9.t0 instanceof Error) {
              message = _context9.t0.message;
            } else {
              message = 'Unable to load session details';
            }

            return _context9.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .AllSessionDetailsResponse */ .FU({
              error: message
            }));

          case 18:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 14]]);
  }));

  return function readAllSessionDetails(_x27) {
    return _ref9.apply(this, arguments);
  };
}();
var readSessionDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(sessionId) {
    var url, res, resJson, message;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            url = "/api/backend/v1/sessions/details/".concat(sessionId);
            _context10.next = 4;
            return fetchWithAuth(url);

          case 4:
            res = _context10.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context10.next = 7;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 7:
            _context10.next = 9;
            return res.json();

          case 9:
            resJson = _context10.sent;
            return _context10.abrupt("return", new SessionDetailsResponse({
              data: _objectSpread(_objectSpread({}, resJson.sessionDetails.statusCounts), resJson.sessionDetails.additionalSessionCounts)
            }));

          case 13:
            _context10.prev = 13;
            _context10.t0 = _context10["catch"](0);

            if (_context10.t0 instanceof Error) {
              message = _context10.t0.message;
            } else {
              message = 'Unable to load session details';
            }

            return _context10.abrupt("return", new SessionDetailsResponse({
              error: message
            }));

          case 17:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 13]]);
  }));

  return function readSessionDetails(_x28) {
    return _ref10.apply(this, arguments);
  };
}()));
var readSessionDashboard = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(sessionId) {
    var res, resJson, message;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return fetchWithAuth("/api/backend/v1/sessions/dashboard/".concat(sessionId));

          case 3:
            res = _context11.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context11.next = 6;
              break;
            }

            throw new Error("Server did not return a valid response");

          case 6:
            _context11.next = 8;
            return res.json();

          case 8:
            resJson = _context11.sent;
            return _context11.abrupt("return", new SessionDashboardResponse({
              data: resJson
            }));

          case 12:
            _context11.prev = 12;
            _context11.t0 = _context11["catch"](0);

            if (_context11.t0 instanceof Error) {
              message = _context11.t0.message;
            } else {
              message = 'Unable to fetch session health score';
            }

            return _context11.abrupt("return", new SessionDashboardResponse({
              error: message
            }));

          case 16:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 12]]);
  }));

  return function readSessionDashboard(_x29) {
    return _ref11.apply(this, arguments);
  };
}()));
var createSession = /*#__PURE__*/function () {
  var _ref12 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12(session) {
    var image, body, _iterator, _step, key, res, resText, sessionId, message;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            image = session.image;
            body = new FormData();
            _iterator = _createForOfIteratorHelper(Object.keys(session));
            _context12.prev = 4;

            _iterator.s();

          case 6:
            if ((_step = _iterator.n()).done) {
              _context12.next = 13;
              break;
            }

            key = _step.value;

            if (!(key === 'image')) {
              _context12.next = 10;
              break;
            }

            return _context12.abrupt("continue", 11);

          case 10:
            if (session[key] != null && typeof session[key] != 'undefined') {
              body.append("Session.".concat(key), session[key]);
            }

          case 11:
            _context12.next = 6;
            break;

          case 13:
            _context12.next = 18;
            break;

          case 15:
            _context12.prev = 15;
            _context12.t0 = _context12["catch"](4);

            _iterator.e(_context12.t0);

          case 18:
            _context12.prev = 18;

            _iterator.f();

            return _context12.finish(18);

          case 21:
            if (image instanceof Blob) {
              body.append('Image', image);
            }

            _context12.next = 24;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions", {
              method: 'POST',
              body: body
            });

          case 24:
            res = _context12.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context12.next = 31;
              break;
            }

            _context12.next = 28;
            return res.text();

          case 28:
            resText = _context12.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 31:
            _context12.next = 33;
            return res.text();

          case 33:
            sessionId = _context12.sent;
            return _context12.abrupt("return", {
              sessionId: sessionId
            });

          case 37:
            _context12.prev = 37;
            _context12.t1 = _context12["catch"](0);

            if (_context12.t1 instanceof Error) {
              message = _context12.t1.message;
            } else {
              message = 'Unable to create session';
            }

            return _context12.abrupt("return", {
              error: message
            });

          case 41:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 37], [4, 15, 18, 21]]);
  }));

  return function createSession(_x30) {
    return _ref12.apply(this, arguments);
  };
}();
var archiveSession = /*#__PURE__*/function () {
  var _ref13 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee13(sessionId) {
    var res, resText, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions/archive/".concat(sessionId), {
              method: "PUT"
            });

          case 3:
            res = _context13.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context13.next = 10;
              break;
            }

            _context13.next = 7;
            return res.text();

          case 7:
            resText = _context13.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 10:
            _context13.next = 16;
            break;

          case 12:
            _context13.prev = 12;
            _context13.t0 = _context13["catch"](0);

            if (_context13.t0 instanceof Error) {
              message = _context13.t0.message;
            } else {
              message = 'Unable to archive session';
            }

            return _context13.abrupt("return", {
              error: message
            });

          case 16:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 12]]);
  }));

  return function archiveSession(_x31) {
    return _ref13.apply(this, arguments);
  };
}();
var unarchiveSession = /*#__PURE__*/function () {
  var _ref14 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee14(sessionId) {
    var res, resText, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions/un-archive/".concat(sessionId), {
              method: "PUT"
            });

          case 3:
            res = _context14.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context14.next = 10;
              break;
            }

            _context14.next = 7;
            return res.text();

          case 7:
            resText = _context14.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 10:
            _context14.next = 16;
            break;

          case 12:
            _context14.prev = 12;
            _context14.t0 = _context14["catch"](0);

            if (_context14.t0 instanceof Error) {
              message = _context14.t0.message;
            } else {
              message = 'Unable to unarchive session';
            }

            return _context14.abrupt("return", {
              error: message
            });

          case 16:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 12]]);
  }));

  return function unarchiveSession(_x32) {
    return _ref14.apply(this, arguments);
  };
}();
var deleteSession = /*#__PURE__*/function () {
  var _ref15 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee15(sessionId) {
    var res, resText, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions/".concat(sessionId), {
              method: 'DELETE'
            });

          case 3:
            res = _context15.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context15.next = 10;
              break;
            }

            _context15.next = 7;
            return res.text();

          case 7:
            resText = _context15.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 10:
            _context15.next = 16;
            break;

          case 12:
            _context15.prev = 12;
            _context15.t0 = _context15["catch"](0);

            if (_context15.t0 instanceof Error) {
              message = _context15.t0.message;
            } else {
              message = 'Unable to create session';
            }

            return _context15.abrupt("return", {
              error: message
            });

          case 16:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 12]]);
  }));

  return function deleteSession(_x33) {
    return _ref15.apply(this, arguments);
  };
}();
var editSession = /*#__PURE__*/function () {
  var _ref16 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee16(session) {
    var image, body, _iterator2, _step2, key, res, resText, message;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            image = session.image;
            body = new FormData();
            _iterator2 = _createForOfIteratorHelper(Object.keys(session));
            _context16.prev = 4;

            _iterator2.s();

          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context16.next = 13;
              break;
            }

            key = _step2.value;

            if (!(key === 'image')) {
              _context16.next = 10;
              break;
            }

            return _context16.abrupt("continue", 11);

          case 10:
            if (session[key] != null && typeof session[key] != 'undefined') {
              body.append("Session.".concat(key), session[key]);
            }

          case 11:
            _context16.next = 6;
            break;

          case 13:
            _context16.next = 18;
            break;

          case 15:
            _context16.prev = 15;
            _context16.t0 = _context16["catch"](4);

            _iterator2.e(_context16.t0);

          case 18:
            _context16.prev = 18;

            _iterator2.f();

            return _context16.finish(18);

          case 21:
            if (image instanceof Blob) {
              body.append('Image', image);
            }

            _context16.next = 24;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions", {
              method: 'PUT',
              body: body
            });

          case 24:
            res = _context16.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context16.next = 31;
              break;
            }

            _context16.next = 28;
            return res.text();

          case 28:
            resText = _context16.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 31:
            return _context16.abrupt("return", res);

          case 34:
            _context16.prev = 34;
            _context16.t1 = _context16["catch"](0);

            if (_context16.t1 instanceof Error) {
              message = _context16.t1.message;
            } else {
              message = 'Unable to edit session';
            }

            return _context16.abrupt("return", {
              error: message
            });

          case 38:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 34], [4, 15, 18, 21]]);
  }));

  return function editSession(_x34) {
    return _ref16.apply(this, arguments);
  };
}();
var updateSessionSortIndexes = /*#__PURE__*/function () {
  var _ref17 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee17(sessions) {
    var data, body, res, resText, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            data = sessions.map(function (s, i) {
              return {
                id: s.id,
                sortIndex: s.sortIndex
              };
            });
            body = JSON.stringify(data);
            _context17.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/sessions/updatesortindexes", {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: body
            });

          case 5:
            res = _context17.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context17.next = 12;
              break;
            }

            _context17.next = 9;
            return res.text();

          case 9:
            resText = _context17.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 12:
            return _context17.abrupt("return", res);

          case 15:
            _context17.prev = 15;
            _context17.t0 = _context17["catch"](0);

            if (_context17.t0 instanceof Error) {
              message = _context17.t0.message;
            } else {
              message = 'Unable to edit session sort indexes';
            }

            return _context17.abrupt("return", {
              error: message
            });

          case 19:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 15]]);
  }));

  return function updateSessionSortIndexes(_x35) {
    return _ref17.apply(this, arguments);
  };
}();
var downloadSessionDataInCSV = /*#__PURE__*/function () {
  var _ref18 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee18(sessionId, sessionName) {
    var fetchUrl, res, resText, url, link, responseObject, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            fetchUrl = "/api/backend/v1/sessions/csv/".concat(sessionId);
            _context18.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "GET",
              headers: {
                responseType: "blob"
              }
            });

          case 4:
            res = _context18.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context18.next = 11;
              break;
            }

            _context18.next = 8;
            return res.text();

          case 8:
            resText = _context18.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context18.t0 = URL;
            _context18.next = 14;
            return res.blob();

          case 14:
            _context18.t1 = _context18.sent;
            url = _context18.t0.createObjectURL.call(_context18.t0, _context18.t1);
            link = document.createElement("a");
            link.href = url;
            link.download = "".concat(sessionName, ".csv");
            link.click();
            _context18.next = 22;
            return res.json();

          case 22:
            responseObject = _context18.sent;
            return _context18.abrupt("return", {
              response: responseObject.success
            });

          case 26:
            _context18.prev = 26;
            _context18.t2 = _context18["catch"](0);

            if (_context18.t2 instanceof Error) {
              message = _context18.t2.message;
            } else {
              message = "Unable to download csv";
            }

            return _context18.abrupt("return", {
              error: message
            });

          case 30:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 26]]);
  }));

  return function downloadSessionDataInCSV(_x36, _x37) {
    return _ref18.apply(this, arguments);
  };
}();
var downloadSessionHistoricalDataInCSV = /*#__PURE__*/function () {
  var _ref19 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee19(sessionId, sessionName) {
    var fetchUrl, res, resText, url, link, responseObject, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            fetchUrl = "/api/backend/v1/sessions/csv/history/".concat(sessionId);
            _context19.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "GET",
              headers: {
                responseType: "blob"
              }
            });

          case 4:
            res = _context19.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context19.next = 11;
              break;
            }

            _context19.next = 8;
            return res.text();

          case 8:
            resText = _context19.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context19.t0 = URL;
            _context19.next = 14;
            return res.blob();

          case 14:
            _context19.t1 = _context19.sent;
            url = _context19.t0.createObjectURL.call(_context19.t0, _context19.t1);
            link = document.createElement("a");
            link.href = url;
            link.download = "".concat(sessionName, " History.csv");
            link.click();
            _context19.next = 22;
            return res.json();

          case 22:
            responseObject = _context19.sent;
            return _context19.abrupt("return", {
              response: responseObject.success
            });

          case 26:
            _context19.prev = 26;
            _context19.t2 = _context19["catch"](0);

            if (_context19.t2 instanceof Error) {
              message = _context19.t2.message;
            } else {
              message = "Unable to download csv";
            }

            return _context19.abrupt("return", {
              error: message
            });

          case 30:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 26]]);
  }));

  return function downloadSessionHistoricalDataInCSV(_x38, _x39) {
    return _ref19.apply(this, arguments);
  };
}();
var downloadSessionLeadBookersDataInCSV = /*#__PURE__*/function () {
  var _ref20 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee20(sessionId, sessionName) {
    var fetchUrl, res, resText, url, link, responseObject, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;
            fetchUrl = "/api/backend/v1/sessions/csv/leadbookers/".concat(sessionId);
            _context20.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "GET",
              headers: {
                responseType: "blob"
              }
            });

          case 4:
            res = _context20.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context20.next = 11;
              break;
            }

            _context20.next = 8;
            return res.text();

          case 8:
            resText = _context20.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context20.t0 = URL;
            _context20.next = 14;
            return res.blob();

          case 14:
            _context20.t1 = _context20.sent;
            url = _context20.t0.createObjectURL.call(_context20.t0, _context20.t1);
            link = document.createElement("a");
            link.href = url;
            link.download = "".concat(sessionName, " Lead bookers.csv");
            link.click();
            _context20.next = 22;
            return res.json();

          case 22:
            responseObject = _context20.sent;
            return _context20.abrupt("return", {
              response: responseObject.success
            });

          case 26:
            _context20.prev = 26;
            _context20.t2 = _context20["catch"](0);

            if (_context20.t2 instanceof Error) {
              message = _context20.t2.message;
            } else {
              message = "Unable to download ticket";
            }

            return _context20.abrupt("return", {
              error: message
            });

          case 30:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[0, 26]]);
  }));

  return function downloadSessionLeadBookersDataInCSV(_x40, _x41) {
    return _ref20.apply(this, arguments);
  };
}();
var getSessionScanStatistics = /*#__PURE__*/function () {
  var _ref21 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee21(sessionId) {
    var fetchUrl, res, resText, responseObject, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;
            fetchUrl = "/api/backend/v1/sessions/scanstatistics/".concat(sessionId);
            _context21.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "GET"
            });

          case 4:
            res = _context21.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context21.next = 11;
              break;
            }

            _context21.next = 8;
            return res.text();

          case 8:
            resText = _context21.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context21.next = 13;
            return res.json();

          case 13:
            responseObject = _context21.sent;
            return _context21.abrupt("return", {
              data: responseObject
            });

          case 17:
            _context21.prev = 17;
            _context21.t0 = _context21["catch"](0);

            if (_context21.t0 instanceof Error) {
              message = _context21.t0.message;
            } else {
              message = "Unable to get session scan statistics";
            }

            return _context21.abrupt("return", {
              error: message
            });

          case 21:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[0, 17]]);
  }));

  return function getSessionScanStatistics(_x42) {
    return _ref21.apply(this, arguments);
  };
}();

/***/ })

}]);